import {
  ChangeDetectorRef, ChangeDetectionStrategy, Component, EventEmitter, Output,
} from '@angular/core';
import { Observable } from 'rxjs';
import * as _ from 'lodash';

import { columns } from './columns';

import { FrontendSearchWidgetComponent } from 'shared/search-widget/frontend-search-widget.component';
import { HiddenScrollComponent } from 'shared/scroll/hidden-scroll/hidden-scroll.component';

import { ListManagerService } from 'shared/list-manager/list-manager.service';


@Component({
  moduleId: module.id,
  selector: 'assets-lists-search',
  templateUrl: 'assets-lists-search.component.html',
  styleUrls: ['assets-lists-search.component.scss'],
  providers: [
    {provide: 'LIST_TYPE', useValue: 'asset'},
    ListManagerService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssetsListsSearchComponent extends FrontendSearchWidgetComponent {

  @Output() listSelect: EventEmitter<any> = new EventEmitter<any>();

  columns: any = columns;

  constructor(
    private listService: ListManagerService,
    private ref: ChangeDetectorRef,
  ) {
    super();
  }

  onRowClick(list: any) {
    _.each(this.data, (item: any) => {
      if (item.selected && item._id !== list._id) {
        item.selected = false;
      }
    });
    this.ref.markForCheck();
    this.listSelect.emit(list);
  }

  public fetchLists(): void {
    this.listService.fetch()
    .subscribe((data: Array<any>) => {
      this.data = data;
      _.defer(() => {
        this.ref.markForCheck();
      });
    });
  }

  public searchByTerm(value: string): void {
    this.searchTerm = value;
    this.ref.markForCheck();
  }
}
